export default __webpack_public_path__ + "static/dashboard-360673dfd110b129107daf593472b415.png";